import React, {FC} from 'react'

export const CardBody: FC<{children: React.ReactNode; className?: string}> = ({children, className}) => {
  return <div className={`card-body py-4 ${className || ''}`}>{children}</div>
}

export const CardHeader: FC<{children: React.ReactNode; className?: string}> = ({children, className}) => {
  return <div className={`card-header border-0 pt-6 ${className || ''}`}>{children}</div>
}

export const CardHeaderToolbar: FC<{children: React.ReactNode}> = ({children}) => {
  return <div className='card-toolbar'>{children}</div>
}

export const CardHeaderTitle: FC<{children: React.ReactNode; className?: string}> = ({children, className}) => {
  return <h5 className={`card-title ${className || ''}`}>{children}</h5>
}

export const CardFooter: FC<{children: React.ReactNode}> = ({children}) => {
  return <div className='card-footer'>{children}</div>
}

export const Card: FC<{children: React.ReactNode; className?: string}> = ({children, className}) => {
  return <div className={`card ${className || ''}`}>{children}</div>
}
